import { render, staticRenderFns } from "./PermissionRoleListTop.vue?vue&type=template&id=6a8a469b&"
import script from "./PermissionRoleListTop.vue?vue&type=script&lang=js&"
export * from "./PermissionRoleListTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports